import { render } from "./TotalAnualPrevistoGarantePayView.vue?vue&type=template&id=56fef65c&scoped=true"
import script from "./TotalAnualPrevistoGarantePayView.vue?vue&type=script&lang=js"
export * from "./TotalAnualPrevistoGarantePayView.vue?vue&type=script&lang=js"

import "./TotalAnualPrevistoGarantePayView.vue?vue&type=style&index=0&id=56fef65c&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fef65c"]])

export default __exports__